"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

var __metadata = this && this.__metadata || function (k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var typescript_ioc_1 = require("@logio/typescript-ioc");

var ValueDifference_1 = require("../../core/model/ValueDifference");

var ForecastChangeProductDTOConverter_1 = require("./ForecastChangeProductDTOConverter");

var WindowChangeDTOConverter_1 = require("./WindowChangeDTOConverter");
/**
 * @author Jan Prokop
 */


var WindowChangeDTOConverterImpl =
/*#__PURE__*/
function (_WindowChangeDTOConve) {
  _inherits(WindowChangeDTOConverterImpl, _WindowChangeDTOConve);

  function WindowChangeDTOConverterImpl() {
    _classCallCheck(this, WindowChangeDTOConverterImpl);

    return _possibleConstructorReturn(this, _getPrototypeOf(WindowChangeDTOConverterImpl).apply(this, arguments));
  }

  _createClass(WindowChangeDTOConverterImpl, [{
    key: "toObject",
    value: function toObject(source, conversions) {
      var _this = this;

      return {
        id: source.id,
        priceValidityStart: conversions.asObject(source, 'priceValidityStart', ValueDifference_1.deserializeValueDifferenceMoment(conversions)),
        priceValidityEnd: conversions.asObject(source, 'priceValidityEnd', ValueDifference_1.deserializeValueDifferenceMoment(conversions)),
        workflowState: source.workflowState,
        windowDeleted: source.windowDeleted || false,
        windowCreated: source.windowCreated || false,
        windowItems: conversions.asObjectList(source, 'windowItems', function (ch) {
          return _this.forecastChangeProductDTOConverter.toObject(ch, conversions);
        })
      };
    }
  }, {
    key: "toDocument",
    value: function toDocument(source, conversions) {
      var _this2 = this;

      return {
        id: source.id,
        priceValidityStart: conversions.asObject(source, 'priceValidityStart', ValueDifference_1.serializeValueDifferenceMoment(conversions)),
        priceValidityEnd: conversions.asObject(source, 'priceValidityEnd', ValueDifference_1.serializeValueDifferenceMoment(conversions)),
        workflowState: source.workflowState,
        windowDeleted: source.windowDeleted,
        windowCreated: source.windowCreated,
        windowItems: conversions.asObjectArray(source, 'windowItems', function (ch) {
          return _this2.forecastChangeProductDTOConverter.toDocument(ch, conversions);
        })
      };
    }
  }]);

  return WindowChangeDTOConverterImpl;
}(WindowChangeDTOConverter_1.WindowChangeDTOConverter);

__decorate([typescript_ioc_1.Inject, __metadata("design:type", ForecastChangeProductDTOConverter_1.ForecastChangeProductDTOConverter)], WindowChangeDTOConverterImpl.prototype, "forecastChangeProductDTOConverter", void 0);

exports.WindowChangeDTOConverterImpl = WindowChangeDTOConverterImpl;